import React, { Component } from "react";
import Loader from 'react-loader-spinner';
import { Button, TextField, FormControl, MenuItem, Select, FormHelperText, InputLabel, Checkbox, FormControlLabel, FormGroup, TextareaAutosize} from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import SearchIcon from '@material-ui/icons/Search';
import Icon from '@material-ui/core/Icon';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import AddBoxIcon from '@material-ui/icons/AddBox';
import Link from '@material-ui/core/Link';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import swal from 'sweetalert';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import AuthService from '../../services/auth/auth.service';
import UtilityService from '../../services/utility.service';
import CRMService from '../../services/crm/crm.service';
import utilityService from "../../services/utility.service";

import UserContext from "../../contexts/UserContext";
import NoPermission from "../extras/nopermission.component";
export default class UserProfile extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            columnsheadings: [],
            options: {
                filterType: 'dropdown',
            },
            show: false,
            error: {
                status: false,
                message: ''
            },
            loadingvalues: false,
            user: [],
            searchtext: '',
            searchtextError: false,
            searchButtonLabel: 'Search',
            currentUser: false,
            customerBasicDetails: false,
            customerPreferences: false,
            customerMoreInfo: false,
            customerCoupons: false,
            customerPoints: false,
            customerOrders: false,
            showform: false,
            email: '',
            firstname: '',
            lastname: '',
            phone: '',
            password: '',
            pastrooms: '',
            adults: '',
            customerprofession: '',
            children: '',
            childrenages: '',
            childrenagestable: [],
            corporatecustomer: '',
            others: '',
            facebookurl: '',
            birthday: '',
            anniversary: '',
            foodallergies: '',
            wheelchair: '',
            limitations: '',
            frequentrequests: '',
            region: '',
            country: '',
            oftenbooking: '',
            allowed: true
        };
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    setaccountemail(event) {
        this.setState({
            email: event.target.value,
        });
    }
    setaccountfirstname(event) {
        this.setState({
            firstname: event.target.value,
        });
    }
    setaccountlastname(event) {
        this.setState({
            lastname: event.target.value,
        });
    }
    setaccountphone(event) {
        this.setState({
            phone: event.target.value,
        });
    }
    setaccountpassword(event) {
        this.setState({
            password: event.target.value,
        });
    }

    updateRooms() {
        var pastrooms = this.state.pastrooms;
        var user_id = this.state.currentUser;
        CRMService.saveValues(user_id, 'rooms_prefs', pastrooms)
        .then(response => {
            swal("Rooms Updated", "Room prefrences has been Updated", "success");
        })
        .catch(error => {
            console.log({error});
        });
        console.log({pastrooms});
    }

    updateMoreInfo() {

        CRMService.saveMoreInfo(this.state.currentUser, this.state.adults, this.state.children, this.state.others, this.state.facebookurl, this.state.customerprofession, this.state.corporatecustomer,  this.state.childrenages)
        .then(response => {
            swal("Info Updated", "Information has been Updated", "success");
        })
        .catch(error => {
            console.log({error});
        });
    }

    updateSpecialDates() {
        console.log(this.state);
        var birthday = this.state.birthday;
        var anniversary = this.state.anniversary;
        if(birthday!='' && birthday!=null) {
            birthday = utilityService.format_date(this.state.birthday);
        }
        if(anniversary!='' && anniversary!=null) {
            anniversary = utilityService.format_date(this.state.anniversary);
        }

        CRMService.saveSpecialDates(this.state.currentUser, birthday, anniversary)
        .then(response => {
            swal("Info Updated", "Special dates have been Updated", "success");
        })
        .catch(error => {
            console.log({error});
        });
    }

    updateLimitations() {
        // console.log(this.state);
        CRMService.saveLimitations(this.state.currentUser, this.state.foodallergies, this.state.wheelchair, this.state.limitations, this.state.frequentrequests)
        .then(response => {
            swal("Limitation Updated", "Limitations & Requests have been Updated", "success");
        })
        .catch(error => {
            console.log({error});
        });
    }

    updateAdditionalInfo() {
        CRMService.saveAdditionalInfo(this.state.currentUser, this.state.region, this.state.country, this.state.oftenbooking)
        .then(response => {
            swal("Info Updated", "Additional Informations have been Updated", "success");
        })
        .catch(error => {
            console.log({error});
        });
    }

    componentDidMount() {
        this.setState({
            columnsheadings:  [
                { field: 'id', headerName: 'ID', width: 130 },
                { field: 'entry', headerName: 'Points History', width: 400 },
                { field: 'date', headerName: 'Date', width: 150 },
                { field: 'creds', headerName: 'Points Earned / Redeemed', width: 300 },
            ]
        });

        console.log(this.props.match);
        setTimeout(() => {
            if (typeof this.props.params.userid == 'undefined') {
                this.setState({
                    currentUser: false
                });
            } else {
                this.setState({
                    currentUser: this.props.params.userid
                });
                if (this.state.currentUser != 0) {
                    this.viewDetails(this.state.currentUser);
                }
            }
        }, 2000);

        AuthService.checklogin().then(user => {
            this.setState({
                user: user
            });

            AuthService.getUserPermisions(user)
            .then(response => {
                var userpermissions = response.data;
                console.log({userpermissions});
                    if(userpermissions.includes('crm') || userpermissions.includes('all')) {
                    console.log('You are allowed!');
                    this.setState({
                        allowed: true
                    });
                } else {
                    console.log('You are not allowed!');
                    this.setState({
                        allowed: false
                    });
                }
            })

            console.log({ user });
        }).catch(error => {
            window.location.href = '/login';
        });
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.searchCustomer();
        }
    }

    showForm = () => {
        this.setState({
            showform: !this.state.showform
        });
    }

    createAccount = () => {
        if(this.state.email=='' && this.state.firstname=='' && this.state.lastname=='' && this.state.phone=='' && this.state.password=='') {
            swal("Enter all details", "Fill all inputs to create account", "warning");
        } else {
            CRMService.createAccount(this.state.email, this.state.firstname, this.state.lastname, this.state.phone, this.state.password)
            .then(response => {

                console.log({response});
                if(response.data=='error') {
                    swal("Account Exists", "Account with entered email already exists", "error");
                } else {
                    this.setState({
                        searchtext: this.state.email
                    });
                    var self=this;
                    setTimeout(function(){
                        self.setState({
                            email: '',
                            firstname: '',
                            lastname: '',
                            phone: '',
                            password: '',
                            showform: false
                        });
                        self.searchCustomer();
                        swal("Account Created", "Account has been created", "success");
                    }, 1000);
                    
                }
            })
            .catch(error => {
                swal("Enter all details", "Fill all inputs to create account", "warning");
            });
        }
    }

    searchCustomer = () => {

        this.setState({
            searchtextError: this.state.searchtext == '',
            data: [],
            searchButtonLabel: 'Fetching...',
            customerBasicDetails: false,
            customerPreferences: false,
            customerMoreInfo: false,
            customerCoupons: false,
            customerPoints: false,
            customerOrders: false,
            currentUser: false,
            loadingvalues: true,
            email: '',
            firstname: '',
            lastname: '',
            phone: '',
            password: '',
            pastrooms: '',
            adults: '',
            customerprofession: '',
            children: '',
            childrenages: '',
            childrenagestable: [],
            corporatecustomer: '',
            others: '',
            facebookurl: '',
            birthday: '',
            anniversary: '',
            foodallergies: '',
            wheelchair: '',
            limitations: '',
            frequentrequests: '',
            region: '',
            country: '',
            oftenbooking: '',
        });

        if (this.state.searchtext != '') {
            CRMService.searchCustomers(this.state.searchtext)
            .then(response => {
                if(response.data.length>0) {
                    this.setState({
                        data: response.data,
                        searchButtonLabel: 'Search',
                        loadingvalues: false
                    });
                } else {
                    this.setState({
                        searchButtonLabel: 'Search',
                        loadingvalues: false
                    });

                    swal("No Customer Found!", "No customer found for searched value", "info");
                }
            })
            .catch(error => {
                console.log({error});
            });
        }
    }

    viewDetails = (id) => {
        this.setState({
            customerBasicDetails: false,
            customerPreferences: false,
            customerMoreInfo: false,
            customerCoupons: false,
            customerPoints: false,
            customerOrders: false,
            currentUser: id,
            data: [],
            loadingvalues: true,
            email: '',
            firstname: '',
            lastname: '',
            phone: '',
            password: '',
            pastrooms: '',
            adults: '',
            customerprofession: '',
            children: '',
            childrenages: '',
            childrenagestable: [],
            corporatecustomer: '',
            others: '',
            facebookurl: '',
            birthday: '',
            anniversary: '',
            foodallergies: '',
            wheelchair: '',
            limitations: '',
            frequentrequests: '',
            region: '',
            country: '',
            oftenbooking: '',
        });
        console.log({id});
        CRMService.getCustomerBasicDetails(id)
        .then(response => {
            this.setState({
                customerBasicDetails: response.data,
                loadingvalues: false
            });
            
            console.log({response});
        })
        .catch(error => {
            console.log({error});
        });

        CRMService.getCustomerPreferences(id)
        .then(response => {
            this.setState({
                customerPreferences: response.data,
                loadingvalues: false
            });
            if(response.data.pastrooms!='undefined') {
                this.setState({
                    pastrooms: response.data.pastrooms
                });
            }
            // console.log({response});
        })
        .catch(error => {
            console.log({error});
        });

        CRMService.getCustomerMoreInfo(id)
        .then(response => {
            console.log('getCustomerMoreInfo', response);
            this.setState({
                customerMoreInfo: response.data,
                loadingvalues: false
            });
            if(response.data.adults!='undefined') {
                this.setState({
                    adults: response.data.adults
                });
            }
            if(response.data.customerprofession!='undefined') {
                this.setState({
                    customerprofession: response.data.customerprofession
                });
            }
            if(response.data.children!='undefined') {
                this.setState({
                    children: response.data.children
                });
            }
            if(response.data.childrenages!='undefined') {
                this.setState({
                    childrenages: response.data.childrenages,
                    childrenagestable: response.data.childrenagestable
                });
            }
            if(response.data.corporatecustomer!='undefined') {
                this.setState({
                    corporatecustomer: response.data.corporatecustomer
                });
            }
            if(response.data.others!='undefined') {
                this.setState({
                    others: response.data.others
                });
            }
            if(response.data.facebookurl!='undefined') {
                this.setState({
                    facebookurl: response.data.facebookurl
                });
            }
            if(response.data.birthday!='undefined') {
                this.setState({
                    birthday: UtilityService.makeDate(response.data.birthday)
                });
            }
            if(response.data.anniversary!='undefined') {
                this.setState({
                    anniversary: UtilityService.makeDate(response.data.anniversary)
                });
            }
            if(response.data.foodallergies!='undefined') {
                this.setState({
                    foodallergies: response.data.foodallergies
                });
            }
            if(response.data.wheelchair!='undefined') {
                this.setState({
                    wheelchair: response.data.wheelchair
                });
            }
            if(response.data.limitations!='undefined') {
                this.setState({
                    limitations: response.data.limitations
                });
            }
            if(response.data.frequentrequests!='undefined') {
                this.setState({
                    frequentrequests: response.data.frequentrequests
                });
            }
            if(response.data.oftenbooking!='undefined') {
                this.setState({
                    oftenbooking: response.data.oftenbooking
                });
            }
            if(response.data.region!='undefined') {
                this.setState({
                    region: response.data.region
                });
            }
            if(response.data.country!='undefined') {
                this.setState({
                    country: response.data.country
                });
            }
            // console.log({response});
        })
        .catch(error => {
            console.log({error});
        });

        CRMService.getCustomerCoupons(id)
        .then(response => {
            this.setState({
                customerCoupons: response.data,
                loadingvalues: false
            });
            // console.log({response});
        })
        .catch(error => {
            console.log({error});
        });

        CRMService.getCustomerPoints(id)
        .then(response => {
            this.setState({
                customerPoints: response.data,
                loadingvalues: false
            });
            // console.log({response});
        })
        .catch(error => {
            console.log({error});
        });

        CRMService.getCustomerOrders(id)
        .then(response => {
            this.setState({
                customerOrders: response.data,
                loadingvalues: false
            });
            // console.log({response});
        })
        .catch(error => {
            console.log({error});
        });
    }

    changeAgesTable = (year, index) => {
        var childagetableTemp = this.state.childrenagestable;
        childagetableTemp[index].year = year;
        childagetableTemp[index].age = parseInt(new Date().getFullYear()) - parseInt(year);  

        var agesArray = [];
        for(var i = 0; i<childagetableTemp.length; i++){
            agesArray.push(childagetableTemp[i].year);
        }

        this.setState({
            childrenagestable: childagetableTemp,
            childrenages: agesArray.join(',')
        });

        // console.log({childagetableTemp});
        // console.log({agesArray});
    }

    changeNumberOfChildren = (value) => {
        var extraLength = parseInt(value)-parseInt(this.state.childrenagestable.length);
        var newTable = this.state.childrenagestable;
        for(var i =0; i<extraLength; i++) {
            newTable.push({
                year: '',
                age: 0
            });
        }

        if(extraLength<0) {
            newTable.splice(newTable.length - Math.abs(extraLength));
        }

        this.setState({
            children: value,
            childrenagestable: newTable
        });
    }


    render() {
        var { data, columnsheadings, options, show, error, loadingvalues, customerBasicDetails } = this.state;

        const customerSearchStyle = {
            width: '80%',
        };
        const searchContainerStyle = {
            display: 'flex',
            justifyContent: 'center',
            width: '100%'
        };
        const searchButtonStyle = {
            marginLeft: '10px',
            fontSize: '18px'
        }

        if(this.state.allowed==false) {
            return (
                <NoPermission />
            );
        }
        
        return (
            <>
                <div className="row">
                    <div className='col'>
                        <h3><AccountBoxIcon fontSize="large" /> Find Customers Profile</h3>
                        <hr />
                    </div>
                </div>
                <div className="row">
                    <div className='col'>
                        <form action='#' onSubmit={e => {e.preventDefault();}} className='search-customer' noValidate autoComplete="off" style={searchContainerStyle}>
                            <TextField id="outlined-basic" label="Search a customer by ID, Name, Phone or Email Address.." variant="outlined" 
                            value={this.state.searchtext} 
                            onChange={event => this.setState({ searchtext: event.target.value })} style={customerSearchStyle} 
                            error={this.state.searchtextError}
                            helperText={this.state.searchtextError==true ? 'Empty or Invalid Input': '' } 
                            onKeyDown={this._handleKeyDown}
                           />
                            <Button variant="contained" color="primary" style={searchButtonStyle} onClick={this.searchCustomer}>{this.state.searchButtonLabel} <SearchIcon /></Button>
                        </form>
                    </div>
                </div>
                <div className='container'>
                    <div class="row" style={{ marginTop: '10px', marginBottom: '10px' }}>
                        {loadingvalues==true &&
                            <div className='col-12'>
                                <p style={{ color: "#df153b" }}><b><i>Loading Data. Please Wait....</i></b></p>
                                <Loader className='loader-center'
                                    type="Grid"
                                    color="#00BFFF"
                                    height={100}
                                    width={100}
                                />
                            </div>
                        }
                        {data.length > 0 &&
                        <div className='col-12'>
                            <TableContainer component={Paper}>
                                <Table aria-label="Users Search" size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>ID</TableCell>
                                            <TableCell>Email</TableCell>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Phone</TableCell>
                                            <TableCell>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((row) => (
                                            <TableRow key={row.ID}>
                                                <TableCell component="th" scope="row">
                                                    {row.ID}
                                                </TableCell>
                                                <TableCell>{row.user_email}</TableCell>
                                                <TableCell>{row.first_name} {row.last_name}</TableCell>
                                                <TableCell>{row.phone}</TableCell>
                                                <TableCell>
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        endIcon={<Icon>send</Icon>}
                                                        onClick={() => this.viewDetails(row.ID)}
                                                    >View
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        }
                    </div>
                    
                    <div className='row' style={{marginBottom: '30px'}}>
                        <div className='col-12'>
                            <Button variant="contained" color="primary" onClick={this.showForm}>Create Customer <AddBoxIcon style={{marginLeft: '10px', float: 'right'}} /></Button>
                        </div>
                    </div>
                    {this.state.showform!=false && 
                    <div className='row' style={{marginBottom: '30px'}}>
                        <div className='col-12'>
                            <Paper elevation={6} style={{ padding:"45px", width: '50%' }}>
                            <form className={''} noValidate autoComplete="off" style={{textAlign: 'center'}}>
                                <h4>Create New Account</h4>
                                <TextField value={this.state.email} onChange={this.setaccountemail.bind(this)} style={{marginBottom: '10px', width: '100%'}} id="outlined-basic" label="Email" variant="outlined" /><br />
                                <TextField value={this.state.firstname} onChange={this.setaccountfirstname.bind(this)} style={{marginBottom: '10px', width: '100%'}} id="outlined-basic" label="First Name" variant="outlined" /><br />
                                <TextField value={this.state.lastname} onChange={this.setaccountlastname.bind(this)} style={{marginBottom: '10px', width: '100%'}} id="outlined-basic" label="Last Name" variant="outlined" /><br />
                                <TextField value={this.state.phone} onChange={this.setaccountphone.bind(this)} style={{marginBottom: '10px', width: '100%'}} id="outlined-basic" label="Phone Number" variant="outlined" /><br />
                                <TextField value={this.state.password} onChange={this.setaccountpassword.bind(this)} style={{marginBottom: '10px', width: '100%'}} id="outlined-basic" label="Password" variant="outlined" /><br />
                                <Button variant="contained" color="primary" onClick={this.createAccount.bind(this)}>Create <AddBoxIcon style={{marginLeft: '10px', float: 'right'}} /></Button>
                            </form>
                            </Paper>
                        </div>
                    </div>
                    }
                            
                    {(customerBasicDetails != false && customerBasicDetails != null) &&
                        <>
                            <div class="row">
                                <div class="col">
                                    <h5 className='heading-blue'>Customer - Profile Summary</h5>
                                </div>
                            </div>
                            <div class="row" style={{ marginBottom: '25px' }}>
                                <div class="col-10">
                                <Paper elevation={6} style={{ padding:"45px" }}>
                                    <h6 className='subheading-blue'>Customer Details</h6>
                                    <hr />
                                    <div className='summary-container'>
                                        <div className='summary-sub-container'>
                                            <span className='summary-label'>Title</span>
                                            <span className='summary-data'>{customerBasicDetails.title}</span>
                                        </div>
                                        <div className='summary-sub-container'>
                                            <span className='summary-label'>First Name</span>
                                            <span className='summary-data'>{customerBasicDetails.usermeta.first_name[0]}</span>
                                        </div>
                                        <div className='summary-sub-container'>
                                            <span className='summary-label'>Last Name</span>
                                            <span className='summary-data'>{customerBasicDetails.usermeta.last_name[0]}</span>
                                        </div>
                                        <div className='summary-sub-container'>
                                            <span className='summary-label'>Gender</span>
                                            <span className='summary-data'>{customerBasicDetails.gender}</span>
                                        </div>
                                    </div>
                                    <div className='summary-container'>
                                        <div className='summary-sub-container'>
                                            <span className='summary-label'>Phone Number</span>
                                            <span className='summary-data'>{customerBasicDetails.phone}</span>
                                        </div>
                                        <div className='summary-sub-container'>
                                            <span className='summary-label'>Email Address</span>
                                            <span className='summary-data'>{customerBasicDetails.email} 
                                             {/* {
                                            customerBasicDetails.usermeta.billing_email[0]
                                            } */}
                                            </span>
                                        </div>
                                    </div>
                                </Paper>
                                </div>
                                <div class="col-2">
                                    <div className='customer-summary-sidebar'>
                                    <Paper elevation={6} style={{ backgroundColor:'#fff505' }}>
                                            <div className='customer-summary-sidebar-container'>
                                                <span className='summary-label-sidebar'>Customer Rank</span>
                                            <span className='summary-data-sidebar'>{customerBasicDetails.rank}</span>
                                            </div>
                                        </Paper>
                                        <Paper elevation={6}>
                                            <div className='customer-summary-sidebar-container'>
                                                <span className='summary-label-sidebar'>Total Spend</span>
                                            <span className='summary-data-sidebar'>{customerBasicDetails.totalspent}</span>
                                            </div>
                                        </Paper>
                                        <Paper elevation={6}>
                                            <div className='customer-summary-sidebar-container'>
                                                <span className='summary-label-sidebar'>No. of Orders</span>
                                            <span className='summary-data-sidebar'>{customerBasicDetails.ordercount}</span>
                                            </div>
                                        </Paper>
                                    <Paper elevation={6} style={{ backgroundColor: '#9df39d' }}>
                                            <div className='customer-summary-sidebar-container'>
                                                <span className='summary-label-sidebar'>Last Order</span>
                                            <span className='summary-data-sidebar'>{customerBasicDetails.lastorder.Date} | <Link href={"https://deals.mu/wp-admin/post.php?post=" + customerBasicDetails.lastorder.ID + "&action=edit"} target="_blank" className='link-primary'>View</Link></span>
                                            </div>
                                        </Paper>
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    <>
                        {(this.state.customerPreferences!=false && this.state.customerPreferences!=null) && 
                        <div class="row">
                            <div class="col">
                                <h5 className='heading-blue'>Know Your Customer</h5>
                            </div>
                        </div>
                        }
                        {(this.state.customerPreferences!=false && this.state.customerPreferences!=null) && 
                        <div class="row" style={{ marginBottom: '25px' }}>
                            <div class="col-12">
                            <Paper elevation={6} style={{ padding:"45px" }}>
                                <h6 className='subheading-blue'>Hotel Booking Prefrences</h6>
                                <hr />
                                <div className='container-fluid'>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-3'><b>Past Hotel Bookings:</b></span>
                                        {(this.state.customerPreferences.pastproducts!='undefined') &&
                                            <span className='col-9'>{this.state.customerPreferences.pastproducts}</span>
                                        }
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-3'><b>Meal Preferences:</b></span>
                                        <span className='col-9'>{this.state.customerPreferences.pastmeals}</span>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-3'><b>Room prefrences:</b></span>
                                        <span className='col-9'><TextField style={{width: '100%'}} onChange={(e) => {this.setState({pastrooms: e.target.value })}} id="outlined-basic" label="Rooms" variant="outlined" value={this.state.pastrooms}/></span>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-12'><Button onClick={this.updateRooms.bind(this)} variant="contained" color="secondary">Update</Button></span>
                                    </div>
                                </div>
                            </Paper>
                            </div>
                        </div>
                        }
                        {this.state.customerMoreInfo!=false && 
                        <div class="row" style={{ marginBottom: '25px' }}>
                            <div class="col-12">
                            <Paper elevation={6} style={{ padding:"45px" }}>
                                <h6 className='subheading-blue'>Who is your customer?</h6>
                                <hr />
                                <div className='container-fluid'>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-2'><b>Adults</b></span>
                                        <span className='col-3'>
                                            {/* <TextField style={{width: '100%'}} id="outlined-basic" label="Adults" onChange={(e) => {this.setState({adults: e.target.value })}} value={this.state.adults} variant="outlined" /> */}
                                            <FormControl className={''} style={{width: '100%'}}>
                                                <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                                Adults
                                                </InputLabel>
                                                <Select
                                                labelId="demo-simple-select-placeholder-label-label"
                                                id="demo-simple-select-placeholder-label"
                                                value={this.state.adults}
                                                onChange={(e) => {this.setState({adults: e.target.value })}}
                                                displayEmpty
                                                className=''
                                                >
                                                <MenuItem value="">
                                                    <em>Not Available</em>
                                                </MenuItem>
                                                <MenuItem value={'1'}>1</MenuItem>
                                                <MenuItem value={'2'}>2</MenuItem>
                                                <MenuItem value={'3'}>3</MenuItem>
                                                <MenuItem value={'4'}>4</MenuItem>
                                                <MenuItem value={'5'}>5</MenuItem>
                                                <MenuItem value={'6'}>6</MenuItem>
                                                <MenuItem value={'7'}>7</MenuItem>
                                                <MenuItem value={'8'}>8</MenuItem>
                                                <MenuItem value={'9'}>9</MenuItem>
                                                <MenuItem value={'10'}>10</MenuItem>
                                                </Select>
                                                <FormHelperText>Adults</FormHelperText>
                                            </FormControl>
                                        </span>
                                        <span className='col-2'></span>
                                        <span className='col-2'><b>Customer Profession</b></span>
                                        <span className='col-3'><TextField style={{width: '100%'}} id="outlined-basic" label="Customer Profession" onChange={(e) => {this.setState({customerprofession: e.target.value })}} value={this.state.customerprofession} variant="outlined" /></span>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-2'><b>Children</b></span>
                                        <span className='col-3'>
                                            <FormControl className={''} style={{width: '100%'}}>
                                                <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                                Children
                                                </InputLabel>
                                                <Select
                                                labelId="demo-simple-select-placeholder-label-label"
                                                id="demo-simple-select-placeholder-label"
                                                value={this.state.children}
                                                onChange={(e) => {this.changeNumberOfChildren(e.target.value)}}
                                                displayEmpty
                                                className=''
                                                >
                                                <MenuItem value="">
                                                    <em>Not Available</em>
                                                </MenuItem>
                                                <MenuItem value={'1'}>1</MenuItem>
                                                <MenuItem value={'2'}>2</MenuItem>
                                                <MenuItem value={'3'}>3</MenuItem>
                                                <MenuItem value={'4'}>4</MenuItem>
                                                <MenuItem value={'5'}>5</MenuItem>
                                                <MenuItem value={'6'}>6</MenuItem>
                                                <MenuItem value={'7'}>7</MenuItem>
                                                <MenuItem value={'8'}>8</MenuItem>
                                                <MenuItem value={'9'}>9</MenuItem>
                                                <MenuItem value={'10'}>10</MenuItem>
                                                </Select>
                                            </FormControl>
                                            <TextField style={{width: '100%', marginTop: '10px', display: 'none'}} id="outlined-basic" type="hidden" label="Children Ages" onChange={(e) => {this.setState({childrenages: e.target.value })}} value={this.state.childrenages} variant="outlined" />
                                            <table className="table table-striped table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Birth Year</th>
                                                        <th>Age</th>
                                                    </tr>
                                                </thead>
                                                <tbody id="children-ages-tbody">
                                                    {this.state.childrenagestable.map((row, index) => (
                                                        <tr key={index}>
                                                            <td><input type="number" className='child-ages-input' value={row.year} placeholder="Year" style={{width: "100%"}} onChange={(e) => {this.changeAgesTable(e.target.value, index)}} /></td>
                                                            <td className='child-ages-input-cal'>{row.age}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </span>
                                        <span className='col-2'></span>
                                        <span className='col-2'><b>Corporate Customer</b></span>
                                        <span className='col-3'>
                                            {/* <TextField style={{width: '100%'}} id="outlined-basic" label="Corporate Customer" onChange={(e) => {this.setState({corporatecustomer: e.target.value })}} value={this.state.corporatecustomer} variant="outlined" /> */}
                                            <FormControl className={''} style={{width: '100%'}}>
                                                <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                                Corporate Customer
                                                </InputLabel>
                                                <Select
                                                labelId="demo-simple-select-placeholder-label-label"
                                                id="demo-simple-select-placeholder-label"
                                                value={this.state.corporatecustomer}
                                                onChange={(e) => {this.setState({corporatecustomer: e.target.value })}}
                                                displayEmpty
                                                className=''
                                                >
                                                <MenuItem value="">
                                                    <em>Not Available</em>
                                                </MenuItem>
                                                <MenuItem value={'Yes'}>Yes</MenuItem>
                                                <MenuItem value={'No'}>No</MenuItem>
                                                </Select>
                                                <FormHelperText>Corporate Customer</FormHelperText>
                                            </FormControl>
                                        </span>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-2'><b>Others</b></span>
                                        <span className='col-3'><TextField style={{width: '100%'}} id="outlined-basic" label="Others" onChange={(e) => {this.setState({others: e.target.value })}} value={this.state.others} variant="outlined" /></span>
                                        <span className='col-2'></span>
                                        <span className='col-2'><b>URL to facebook profile</b></span>
                                        <span className='col-3'><TextField style={{width: '100%'}} id="outlined-basic" label="Profile" onChange={(e) => {this.setState({facebookurl: e.target.value })}} value={this.state.facebookurl} variant="outlined" /></span>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-12'><Button onClick={this.updateMoreInfo.bind(this)} variant="contained" color="secondary">Update</Button></span>
                                    </div>
                                </div>
                            </Paper>
                            </div>
                        </div>
                        }
                        {this.state.customerMoreInfo!=false && 
                        <div class="row" style={{ marginBottom: '25px' }}>
                            <div class="col-12">
                            <Paper elevation={6} style={{ padding:"45px" }}>
                                <h6 className='subheading-blue'>Special Dates</h6>
                                <hr />
                                <div className='container-fluid'>
                                <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-2'><b>Birthday</b></span>
                                        <span className='col-3'>
                                           
                                            <DatePicker
                                            dateFormat="dd-MM-yyyy"
                                            selected={this.state.birthday}
                                            onChange={(date) => {this.setState({birthday: date })}}
                                            placeholderText="Birthday"
                                            className='form-control'
                                            />
                                           
                                            {/* <TextField style={{width: '100%'}} id="outlined-basic" label="Birthday" onChange={(e) => {this.setState({birthday: e.target.value })}} value={this.state.birthday} variant="outlined" /> */}
                                        </span>
                                        <span className='col-2'></span>
                                        <span className='col-2'><b>Anniversary</b></span>
                                        <span className='col-3'>
                                            <DatePicker
                                            dateFormat="dd-MM-yyyy"
                                            selected={this.state.anniversary}
                                            onChange={(date) => {this.setState({anniversary: date })}}
                                            placeholderText="Anniversary"
                                            className='form-control'
                                            />
                                            {/* <TextField style={{width: '100%'}} id="outlined-basic" label="Anniversary" onChange={(e) => {this.setState({anniversary: e.target.value })}} value={this.state.anniversary} variant="outlined" /> */}
                                        </span>
                                    </div>
                                </div>
                                <div className='row' style={{marginBottom: '10px'}}>
                                    <span className='col-12'><Button onClick={this.updateSpecialDates.bind(this)} variant="contained" color="secondary">Update</Button></span>
                                </div>
                            </Paper>
                            </div>
                        </div>
                        }
                        {this.state.customerMoreInfo!=false && 
                        <div class="row" style={{ marginBottom: '25px' }}>
                            <div class="col-12">
                            <Paper elevation={6} style={{ padding:"45px" }}>
                                <h6 className='subheading-blue'>Limitations & Requests</h6>
                                <hr />
                                <div className='container-fluid'>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-2'><b>Food Allergies</b></span>
                                        <span className='col-3'><TextField style={{width: '100%'}} id="outlined-basic" label="Food Allergies" onChange={(e) => {this.setState({foodallergies: e.target.value })}} value={this.state.foodallergies} variant="outlined" /></span>
                                        <span className='col-2'></span>
                                        <span className='col-2'><b>Wheelchair</b></span>
                                        <span className='col-3'>
                                            {/* <TextField style={{width: '100%'}} id="outlined-basic" label="Wheelchair" onChange={(e) => {this.setState({wheelchair: e.target.value })}} value={this.state.wheelchair} variant="outlined" /> */}
                                            <FormControl className={''} style={{width: '100%'}}>
                                                <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                                Wheelchair
                                                </InputLabel>
                                                <Select
                                                labelId="demo-simple-select-placeholder-label-label"
                                                id="demo-simple-select-placeholder-label"
                                                value={this.state.wheelchair}
                                                onChange={(e) => {this.setState({wheelchair: e.target.value })}}
                                                displayEmpty
                                                className=''
                                                >
                                                <MenuItem value="">
                                                    <em>Not Available</em>
                                                </MenuItem>
                                                <MenuItem value={'Yes'}>Yes</MenuItem>
                                                <MenuItem value={'No'}>No</MenuItem>
                                                </Select>
                                                <FormHelperText>Wheelchair</FormHelperText>
                                            </FormControl>
                                        </span>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-2'><b>Limitations</b></span>
                                        <span className='col-3'><TextField style={{width: '100%'}} id="outlined-basic" label="Limitations" onChange={(e) => {this.setState({limitations: e.target.value })}} value={this.state.limitations} variant="outlined" /></span>
                                        <span className='col-2'></span>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-2'><b>Frequent requests</b></span>
                                        <span className='col-8'><TextareaAutosize onChange={(e) => {this.setState({frequentrequests: e.target.value })}}  value={this.state.frequentrequests} aria-label="empty textarea" placeholder="Frequent requests" /></span> 
                                        {/* <TextField style={{width: '100%'}} id="outlined-basic" label="Frequent requests" value={this.state.customerMoreInfo.frequentrequests} variant="outlined" />*/}
                                        <span className='col-2'></span>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-12'><Button onClick={this.updateLimitations.bind(this)} variant="contained" color="secondary">Update</Button></span>
                                    </div>
                                </div>
                            </Paper>
                            </div>
                        </div>
                        }
                    </>
                    {this.state.customerMoreInfo!=false && 
                    <>
                        <div class="row">
                            <div class="col">
                                <h5 className='heading-blue'>Additional Information</h5>
                            </div>
                        </div>
                        <div class="row" style={{ marginBottom: '25px' }}>
                            <div class="col-12">
                            <Paper elevation={6} style={{ padding:"45px" }}>
                                <h6 className='subheading-blue'>Additional Information</h6>
                                <hr />
                                <div className='container-fluid'>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-6'>
                                            <FormControl className={''} style={{width: '100%'}}>
                                                <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                                Region
                                                </InputLabel>
                                                <Select
                                                labelId="demo-simple-select-placeholder-label-label"
                                                id="demo-simple-select-placeholder-label"
                                                value={this.state.region}
                                                onChange={(e) => {this.setState({region: e.target.value })}}
                                                displayEmpty
                                                className=''
                                                >
                                                <MenuItem value="">
                                                    <em>Not Available</em>
                                                </MenuItem>
                                                <MenuItem value={'black-river'}>Black River (Flic en Flac)</MenuItem>
                                                <MenuItem value={'flacq'}>Flacq</MenuItem>
                                                <MenuItem value={'grand-port'}>Grand Port</MenuItem>
                                                <MenuItem value={'moka'}>Moka</MenuItem>
                                                <MenuItem value={'pamplemousses'}>Pamplemousses</MenuItem>
                                                <MenuItem value={'plaines-wilhems'}>Plaines Wilhems</MenuItem>
                                                <MenuItem value={'port-louis'}>Port Louis</MenuItem>
                                                <MenuItem value={'riviere-du-rempart'}>Rivière du Rempart</MenuItem>
                                                <MenuItem value={'savanne'}>Savanne</MenuItem>
                                                <MenuItem value={'rodrigues'}>Rodrigues</MenuItem>
                                                </Select>
                                                <FormHelperText>Customer Region</FormHelperText>
                                            </FormControl>
                                        </span>
                                        <span className='col-6'>
                                            <FormControl className={''} style={{width: '100%'}}>
                                                <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                                Country
                                                </InputLabel>
                                                <Select
                                                labelId="demo-simple-select-placeholder-label-label"
                                                id="demo-simple-select-placeholder-label"
                                                value={this.state.country}
                                                onChange={(e) => {this.setState({country: e.target.value })}}
                                                displayEmpty
                                                className=''
                                                >
                                                <MenuItem value="">
                                                    <em>Not Available</em>
                                                </MenuItem>
                                                <MenuItem value="">Select a country / region…</MenuItem><MenuItem value="AX">Åland Islands</MenuItem><MenuItem value="AF">Afghanistan</MenuItem><MenuItem value="AL">Albania</MenuItem><MenuItem value="DZ">Algeria</MenuItem><MenuItem value="AS">American Samoa</MenuItem><MenuItem value="AD">Andorra</MenuItem><MenuItem value="AO">Angola</MenuItem><MenuItem value="AI">Anguilla</MenuItem><MenuItem value="AQ">Antarctica</MenuItem><MenuItem value="AG">Antigua and Barbuda</MenuItem><MenuItem value="AR">Argentina</MenuItem><MenuItem value="AM">Armenia</MenuItem><MenuItem value="AW">Aruba</MenuItem><MenuItem value="AU">Australia</MenuItem><MenuItem value="AT">Austria</MenuItem><MenuItem value="AZ">Azerbaijan</MenuItem><MenuItem value="BS">Bahamas</MenuItem><MenuItem value="BH">Bahrain</MenuItem><MenuItem value="BD">Bangladesh</MenuItem><MenuItem value="BB">Barbados</MenuItem><MenuItem value="BY">Belarus</MenuItem><MenuItem value="PW">Belau</MenuItem><MenuItem value="BE">Belgium</MenuItem><MenuItem value="BZ">Belize</MenuItem><MenuItem value="BJ">Benin</MenuItem><MenuItem value="BM">Bermuda</MenuItem><MenuItem value="BT">Bhutan</MenuItem><MenuItem value="BO">Bolivia</MenuItem><MenuItem value="BQ">Bonaire, Saint Eustatius and Saba</MenuItem><MenuItem value="BA">Bosnia and Herzegovina</MenuItem><MenuItem value="BW">Botswana</MenuItem><MenuItem value="BV">Bouvet Island</MenuItem><MenuItem value="BR">Brazil</MenuItem><MenuItem value="IO">British Indian Ocean Territory</MenuItem><MenuItem value="BN">Brunei</MenuItem><MenuItem value="BG">Bulgaria</MenuItem><MenuItem value="BF">Burkina Faso</MenuItem><MenuItem value="BI">Burundi</MenuItem><MenuItem value="KH">Cambodia</MenuItem><MenuItem value="CM">Cameroon</MenuItem><MenuItem value="CA">Canada</MenuItem><MenuItem value="CV">Cape Verde</MenuItem><MenuItem value="KY">Cayman Islands</MenuItem><MenuItem value="CF">Central African Republic</MenuItem><MenuItem value="TD">Chad</MenuItem><MenuItem value="CL">Chile</MenuItem><MenuItem value="CN">China</MenuItem><MenuItem value="CX">Christmas Island</MenuItem><MenuItem value="CC">Cocos (Keeling) Islands</MenuItem><MenuItem value="CO">Colombia</MenuItem><MenuItem value="KM">Comoros</MenuItem><MenuItem value="CG">Congo (Brazzaville)</MenuItem><MenuItem value="CD">Congo (Kinshasa)</MenuItem><MenuItem value="CK">Cook Islands</MenuItem><MenuItem value="CR">Costa Rica</MenuItem><MenuItem value="HR">Croatia</MenuItem><MenuItem value="CU">Cuba</MenuItem><MenuItem value="CW">Curaçao</MenuItem><MenuItem value="CY">Cyprus</MenuItem><MenuItem value="CZ">Czech Republic</MenuItem><MenuItem value="DK">Denmark</MenuItem><MenuItem value="DJ">Djibouti</MenuItem><MenuItem value="DM">Dominica</MenuItem><MenuItem value="DO">Dominican Republic</MenuItem><MenuItem value="EC">Ecuador</MenuItem><MenuItem value="EG">Egypt</MenuItem><MenuItem value="SV">El Salvador</MenuItem><MenuItem value="GQ">Equatorial Guinea</MenuItem><MenuItem value="ER">Eritrea</MenuItem><MenuItem value="EE">Estonia</MenuItem><MenuItem value="ET">Ethiopia</MenuItem><MenuItem value="FK">Falkland Islands</MenuItem><MenuItem value="FO">Faroe Islands</MenuItem><MenuItem value="FJ">Fiji</MenuItem><MenuItem value="FI">Finland</MenuItem><MenuItem value="FR">France</MenuItem><MenuItem value="GF">French Guiana</MenuItem><MenuItem value="PF">French Polynesia</MenuItem><MenuItem value="TF">French Southern Territories</MenuItem><MenuItem value="GA">Gabon</MenuItem><MenuItem value="GM">Gambia</MenuItem><MenuItem value="GE">Georgia</MenuItem><MenuItem value="DE">Germany</MenuItem><MenuItem value="GH">Ghana</MenuItem><MenuItem value="GI">Gibraltar</MenuItem><MenuItem value="GR">Greece</MenuItem><MenuItem value="GL">Greenland</MenuItem><MenuItem value="GD">Grenada</MenuItem><MenuItem value="GP">Guadeloupe</MenuItem><MenuItem value="GU">Guam</MenuItem><MenuItem value="GT">Guatemala</MenuItem><MenuItem value="GG">Guernsey</MenuItem><MenuItem value="GN">Guinea</MenuItem><MenuItem value="GW">Guinea-Bissau</MenuItem><MenuItem value="GY">Guyana</MenuItem><MenuItem value="HT">Haiti</MenuItem><MenuItem value="HM">Heard Island and McDonald Islands</MenuItem><MenuItem value="HN">Honduras</MenuItem><MenuItem value="HK">Hong Kong</MenuItem><MenuItem value="HU">Hungary</MenuItem><MenuItem value="IS">Iceland</MenuItem><MenuItem value="IN">India</MenuItem><MenuItem value="ID">Indonesia</MenuItem><MenuItem value="IR">Iran</MenuItem><MenuItem value="IQ">Iraq</MenuItem><MenuItem value="IE">Ireland</MenuItem><MenuItem value="IM">Isle of Man</MenuItem><MenuItem value="IL">Israel</MenuItem><MenuItem value="IT">Italy</MenuItem><MenuItem value="CI">Ivory Coast</MenuItem><MenuItem value="JM">Jamaica</MenuItem><MenuItem value="JP">Japan</MenuItem><MenuItem value="JE">Jersey</MenuItem><MenuItem value="JO">Jordan</MenuItem><MenuItem value="KZ">Kazakhstan</MenuItem><MenuItem value="KE">Kenya</MenuItem><MenuItem value="KI">Kiribati</MenuItem><MenuItem value="KW">Kuwait</MenuItem><MenuItem value="KG">Kyrgyzstan</MenuItem><MenuItem value="LA">Laos</MenuItem><MenuItem value="LV">Latvia</MenuItem><MenuItem value="LB">Lebanon</MenuItem><MenuItem value="LS">Lesotho</MenuItem><MenuItem value="LR">Liberia</MenuItem><MenuItem value="LY">Libya</MenuItem><MenuItem value="LI">Liechtenstein</MenuItem><MenuItem value="LT">Lithuania</MenuItem><MenuItem value="LU">Luxembourg</MenuItem><MenuItem value="MO">Macao</MenuItem><MenuItem value="MG">Madagascar</MenuItem><MenuItem value="MW">Malawi</MenuItem><MenuItem value="MY">Malaysia</MenuItem><MenuItem value="MV">Maldives</MenuItem><MenuItem value="ML">Mali</MenuItem><MenuItem value="MT">Malta</MenuItem><MenuItem value="MH">Marshall Islands</MenuItem><MenuItem value="MQ">Martinique</MenuItem><MenuItem value="MR">Mauritania</MenuItem><MenuItem value="MU" selected="selected">Mauritius</MenuItem><MenuItem value="YT">Mayotte</MenuItem><MenuItem value="MX">Mexico</MenuItem><MenuItem value="FM">Micronesia</MenuItem><MenuItem value="MD">Moldova</MenuItem><MenuItem value="MC">Monaco</MenuItem><MenuItem value="MN">Mongolia</MenuItem><MenuItem value="ME">Montenegro</MenuItem><MenuItem value="MS">Montserrat</MenuItem><MenuItem value="MA">Morocco</MenuItem><MenuItem value="MZ">Mozambique</MenuItem><MenuItem value="MM">Myanmar</MenuItem><MenuItem value="NA">Namibia</MenuItem><MenuItem value="NR">Nauru</MenuItem><MenuItem value="NP">Nepal</MenuItem><MenuItem value="NL">Netherlands</MenuItem><MenuItem value="NC">New Caledonia</MenuItem><MenuItem value="NZ">New Zealand</MenuItem><MenuItem value="NI">Nicaragua</MenuItem><MenuItem value="NE">Niger</MenuItem><MenuItem value="NG">Nigeria</MenuItem><MenuItem value="NU">Niue</MenuItem><MenuItem value="NF">Norfolk Island</MenuItem><MenuItem value="KP">North Korea</MenuItem><MenuItem value="MK">North Macedonia</MenuItem><MenuItem value="MP">Northern Mariana Islands</MenuItem><MenuItem value="NO">Norway</MenuItem><MenuItem value="OM">Oman</MenuItem><MenuItem value="PK">Pakistan</MenuItem><MenuItem value="PS">Palestinian Territory</MenuItem><MenuItem value="PA">Panama</MenuItem><MenuItem value="PG">Papua New Guinea</MenuItem><MenuItem value="PY">Paraguay</MenuItem><MenuItem value="PE">Peru</MenuItem><MenuItem value="PH">Philippines</MenuItem><MenuItem value="PN">Pitcairn</MenuItem><MenuItem value="PL">Poland</MenuItem><MenuItem value="PT">Portugal</MenuItem><MenuItem value="PR">Puerto Rico</MenuItem><MenuItem value="QA">Qatar</MenuItem><MenuItem value="RE">Reunion</MenuItem><MenuItem value="RO">Romania</MenuItem><MenuItem value="RU">Russia</MenuItem><MenuItem value="RW">Rwanda</MenuItem><MenuItem value="ST">São Tomé and Príncipe</MenuItem><MenuItem value="BL">Saint Barthélemy</MenuItem><MenuItem value="SH">Saint Helena</MenuItem><MenuItem value="KN">Saint Kitts and Nevis</MenuItem><MenuItem value="LC">Saint Lucia</MenuItem><MenuItem value="SX">Saint Martin (Dutch part)</MenuItem><MenuItem value="MF">Saint Martin (French part)</MenuItem><MenuItem value="PM">Saint Pierre and Miquelon</MenuItem><MenuItem value="VC">Saint Vincent and the Grenadines</MenuItem><MenuItem value="WS">Samoa</MenuItem><MenuItem value="SM">San Marino</MenuItem><MenuItem value="SA">Saudi Arabia</MenuItem><MenuItem value="SN">Senegal</MenuItem><MenuItem value="RS">Serbia</MenuItem><MenuItem value="SC">Seychelles</MenuItem><MenuItem value="SL">Sierra Leone</MenuItem><MenuItem value="SG">Singapore</MenuItem><MenuItem value="SK">Slovakia</MenuItem><MenuItem value="SI">Slovenia</MenuItem><MenuItem value="SB">Solomon Islands</MenuItem><MenuItem value="SO">Somalia</MenuItem><MenuItem value="ZA">South Africa</MenuItem><MenuItem value="GS">South Georgia/Sandwich Islands</MenuItem><MenuItem value="KR">South Korea</MenuItem><MenuItem value="SS">South Sudan</MenuItem><MenuItem value="ES">Spain</MenuItem><MenuItem value="LK">Sri Lanka</MenuItem><MenuItem value="SD">Sudan</MenuItem><MenuItem value="SR">Suriname</MenuItem><MenuItem value="SJ">Svalbard and Jan Mayen</MenuItem><MenuItem value="SZ">Swaziland</MenuItem><MenuItem value="SE">Sweden</MenuItem><MenuItem value="CH">Switzerland</MenuItem><MenuItem value="SY">Syria</MenuItem><MenuItem value="TW">Taiwan</MenuItem><MenuItem value="TJ">Tajikistan</MenuItem><MenuItem value="TZ">Tanzania</MenuItem><MenuItem value="TH">Thailand</MenuItem><MenuItem value="TL">Timor-Leste</MenuItem><MenuItem value="TG">Togo</MenuItem><MenuItem value="TK">Tokelau</MenuItem><MenuItem value="TO">Tonga</MenuItem><MenuItem value="TT">Trinidad and Tobago</MenuItem><MenuItem value="TN">Tunisia</MenuItem><MenuItem value="TR">Turkey</MenuItem><MenuItem value="TM">Turkmenistan</MenuItem><MenuItem value="TC">Turks and Caicos Islands</MenuItem><MenuItem value="TV">Tuvalu</MenuItem><MenuItem value="UG">Uganda</MenuItem><MenuItem value="UA">Ukraine</MenuItem><MenuItem value="AE">United Arab Emirates</MenuItem><MenuItem value="GB">United Kingdom (UK)</MenuItem><MenuItem value="US">United States (US)</MenuItem><MenuItem value="UM">United States (US) Minor Outlying Islands</MenuItem><MenuItem value="UY">Uruguay</MenuItem><MenuItem value="UZ">Uzbekistan</MenuItem><MenuItem value="VU">Vanuatu</MenuItem><MenuItem value="VA">Vatican</MenuItem><MenuItem value="VE">Venezuela</MenuItem><MenuItem value="VN">Vietnam</MenuItem><MenuItem value="VG">Virgin Islands (British)</MenuItem><MenuItem value="VI">Virgin Islands (US)</MenuItem><MenuItem value="WF">Wallis and Futuna</MenuItem><MenuItem value="EH">Western Sahara</MenuItem><MenuItem value="YE">Yemen</MenuItem><MenuItem value="ZM">Zambia</MenuItem><MenuItem value="ZW">Zimbabwe</MenuItem>
                                                </Select>
                                                <FormHelperText>Customer Country</FormHelperText>
                                            </FormControl>
                                        </span>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_hotelAccommodation}  onChange={''} name="checkedA" />}
                                                    label="Hotel Accommodation"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_villaAccommodation}  onChange={''} name="checkedA" />}
                                                    label="Villa Accommodation (optional)"
                                                />
                                            </FormGroup>
                                        </div>
                                       <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_dayPackages}  onChange={''} name="checkedA" />}
                                                    label="Day Packages"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_roomDayUse}  onChange={''} name="checkedA" />}
                                                    label="Room Day Use"
                                                />
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_eveningPackages}  onChange={''} name="checkedA" />}
                                                    label="Evening Packages"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_restaurantDeals}  onChange={''} name="checkedA" />}
                                                    label="Restaurant Deals"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_spaDeals}  onChange={''} name="checkedA" />}
                                                    label="Spa Deals"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_beautyTreatments}  onChange={''} name="checkedA" />}
                                                    label="Beauty Treatments"
                                                />
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_eventDeals}  onChange={''} name="checkedA" />}
                                                    label="Event Deals"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_activityDeals}  onChange={''} name="checkedA" />}
                                                    label="Activity Deals"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_rodriguesDeals}  onChange={''} name="checkedA" />}
                                                    label="Rodrigues Deals"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_luxuryAccommodation}  onChange={''} name="checkedA" />}
                                                    label="Luxury Accommodation"
                                                />
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_budgetAccommodation}  onChange={''} name="checkedA" />}
                                                    label="Budget Accommodation"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_apartmentAccommodation}  onChange={''} name="checkedA" />}
                                                    label="Apartment Accommodation"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className='col-3'>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={<Checkbox checked={this.state.customerMoreInfo.checkboxlist.de_lodgesAccommodation}  onChange={''} name="checkedA" />}
                                                    label="Lodges Accommodation"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className='col-3'></div>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <div className='col-12'>
                                            <FormControl className={''} style={{width: '100%'}}>
                                                <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                                HOW OFTEN DO YOU BOOK FOR OVERNIGHT STAY OR LEISURE RELATED PACKAGES? 
                                                </InputLabel>
                                                <Select
                                                labelId="demo-simple-select-placeholder-label-label"
                                                id="demo-simple-select-placeholder-label"
                                                value={this.state.oftenbooking}
                                                onChange={(e) => {this.setState({oftenbooking: e.target.value })}}
                                                displayEmpty
                                                className=''
                                                >
                                                <MenuItem value="">
                                                    <em>Not Available</em>
                                                </MenuItem>
                                                <MenuItem value={'12+'}>12+ per year</MenuItem>
                                                <MenuItem value={'6-11'}>6-11 per year</MenuItem>
                                                <MenuItem value={'2-5'}>2-5 per year</MenuItem>
                                                <MenuItem value={'1'}>1 or less per year</MenuItem>
                                                </Select>
                                                <FormHelperText>HOW OFTEN DO YOU BOOK FOR OVERNIGHT STAY OR LEISURE RELATED PACKAGES? </FormHelperText>
                                            </FormControl>
                                        </div>
                                    </div>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <span className='col-12'><Button onClick={this.updateAdditionalInfo.bind(this)} variant="contained" color="secondary">Update</Button></span>
                                    </div>
                                </div>
                            </Paper>
                            </div>
                        </div>
                    </>
                    }
                    {(this.state.customerCoupons != false && this.state.customerCoupons!= null) &&
                    <>
                        <div class="row">
                            <div class="col">
                                <h5 className='heading-blue'>Coupons & Credits</h5>
                            </div>
                        </div>
                        <div class="row">
                            {this.state.customerCoupons.map((row) => (
                                <>
                                <div class="col-4">
                                    <Paper elevation={6} style={{padding:'20px', marginBottom: '20px'}}>
                                        <h5 style={{textAlign: 'center', textDecoration: 'underline'}}>{row.type}</h5>
                                        <p><b>Code:</b> {row.posttitle}</p>
                                        <p><b>Amount:</b> {row.offtitle}</p>
                                        <p><b>Status:</b> {row.status}</p>
                                        <p><b>Expiry:</b> {row.date_expires}</p>
                                    </Paper>
                                </div>
                                </>
                            ))}
                        </div>
                    </>
                    }

                    {(this.state.customerPoints != false && this.state.customerBasicDetails!= null && this.state.customerPoints != null && this.state.customerBasicDetails!= false) &&
                    <>
                        <div class="row">
                            <div class="col">
                                <h5 className='heading-blue'>Loyalty Rank & Reward Points History</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div className='col-2'>
                                <Paper elevation={6} style={{padding:'20px', marginBottom: '20px', textAlign: 'center'}}>
                                    <p><b>Points</b></p>
                                    <p>{this.state.customerPoints.points}</p>
                                </Paper>
                            </div>
                            <div className='col-2'>
                                <Paper elevation={6} style={{padding:'20px', marginBottom: '20px', textAlign: 'center', backgroundColor:'#fff505'}}>
                                    <p><b>Rank</b></p>
                                    <p>{customerBasicDetails.rank}</p>
                                </Paper>
                            </div>
                        </div>
                        <div class="row">
                            {this.state.customerPoints.history!=null && 
                                <div className='col' style={{ height: 650, width: '100%' }}>
                                    <DataGrid rows={this.state.customerPoints.history} columns={this.state.columnsheadings} pageSize={10} />
                                </div>
                            }
                        </div>
                    </>
                    }
                    {(this.state.customerOrders != false && this.state.customerOrders != null) && 
                    <>
                        <div class="row" style={{marginTop: '20px'}}>
                            <div class="col">
                                <h5 className='heading-blue'>Order History</h5>
                            </div>
                        </div>
                        {this.state.customerOrders.map((row) => (
                        <div class="row">
                            <div className='col-12'>
                                <Paper elevation={6} style={{padding:'20px', marginBottom: '20px', backgroundColor: '#e1ff98'}}>
                                    <div className='row' style={{marginBottom: '10px'}}>
                                        <div className='col-2'><b>Order No:</b></div>
                                        <div className='col-2'>#{row.id}</div>
                                        <div className='col-2'><b>Order Date:</b></div>
                                        <div className='col-3'>{row.date}</div>
                                        <div className='col-1'><b>Status:</b></div>
                                        <div className='col-2'>{row.status}</div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-2'><b>Price:</b></div>
                                        <div className='col-2'>{row.total}</div>
                                        <div className='col-2'><b>PAYMENT METHOD:</b></div>
                                        <div className='col-3'>{row.paymentmethod}</div>
                                        <div className='col-3'><Link href={row.url} target="_blank" className='link-primary'>View More ></Link></div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <TableContainer component={Paper} style={{marginTop: '20px'}}>
                                                <Table className={''} aria-label="Order details">
                                                    <TableHead style={{backgroundColor: '#bdbdbd'}}>
                                                        <TableRow>
                                                            <TableCell align="left"><b>Package Details</b></TableCell>
                                                            <TableCell align="left"><b>Dates</b></TableCell>
                                                            <TableCell align="left"><b>Booking Summary</b></TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                    {(typeof row.items!='undefined') && 
                                                        row.items.map((item) => (
                                                            <TableRow key={item.id}>
                                                            <TableCell component="th" scope="row">
                                                                <p><b>{item.productname}</b></p>
                                                                <p>{item.sunheading}</p>
                                                            </TableCell>
                                                            <TableCell align="left">
                                                                {item.dates.map((date) => (
                                                                    Object.keys(date).map((oneKey,i)=>{
                                                                        return (
                                                                            <>
                                                                            <p><b>{oneKey}</b></p>
                                                                            <p>{date[oneKey]}</p>
                                                                            </>
                                                                        )
                                                                    })
                                                                ))}
                                                            </TableCell>
                                                            <TableCell align="left">
                                                                {item.bookings.map((booking) => (
                                                                    Object.keys(booking).map((oneKey,i)=>{
                                                                        return (
                                                                            <>
                                                                            <p><b>{oneKey}</b></p>
                                                                            <p>{booking[oneKey]}</p>
                                                                            </>
                                                                        )
                                                                    })
                                                                ))}
                                                            </TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </div>
                                    <div className='row' style={{marginTop: '20px'}}>
                                        <div className='col-12'><b>Special Requests:</b> {row.request}</div>
                                    </div>
                                </Paper>
                            </div>
                        </div>
                        ))}
                    </>
                    }
                </div>
            </>
        );
    }
}